<template>
  <v-content>
    <v-container my-10>
      <v-layout align-center justify-center>
        <v-progress-circular
          :size="55"
          :width="4"
          indeterminate
          color="primary"
          class="mt-12"
          v-if="getDocumentLoadingStatus"
        ></v-progress-circular>
        <document-add-edit-form
          @documentEdited="isDocumentEdited = $event"
        ></document-add-edit-form>
      </v-layout>
      <unsaved-content-warning
        :dialog="unsavedContent"
        @redirect="redirectRoute"
      ></unsaved-content-warning>
    </v-container>
  </v-content>
</template>

<script>
import DocumentAddEditForm from "@/components/documents/DocumentAddEditForm";
import { mapGetters } from "vuex";
import UnsavedContentWarning from "@/components/dialogs/UnsavedContentWarningDialog";

export default {
  components: {
    DocumentAddEditForm,
    UnsavedContentWarning,
  },
  computed: {
    ...mapGetters(["getDocumentLoadingStatus"]),
  },
  data: () => ({
    unsavedContent: { active: false, route: null },
    isDocumentEdited: false,
  }),
  methods: {
    redirectRoute(event) {
      if (event) {
        this.$router.push(this.unsavedContent.route);
      }
      this.unsavedContent.active = false;
      this.unsavedContent.route = null;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!this.isDocumentEdited) {
      next();
    } else {
      if (this.unsavedContent.route) {
        next();
      } else {
        this.unsavedContent.active = true;
        this.unsavedContent.route = to;
        next(false);
      }
    }
  },
};
</script>
